import { Avatar, AvatarGroup, Box, IconButton, Typography } from '@mui/material';
import Images from '../../../../Assets/assetHelper';
import { useStyles } from '../styles';
import { useNavigate } from 'react-router-dom';

const YourGroupCard: React.FC<any> = (group) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const groupName: any = group?.groupName ? group?.groupName : "Title";
  const memberCount: any = group?.memberCount ? group?.memberCount : "-";
  const coverImage: any = group?.coverImage ? group?.coverImage : Images.Images.entreprenursOfKen42;
  const groupId: any = group?.id ? group?.id : "Title";
  const handleJoinClick = () => {
    navigate(`/groups/your-groups/${groupName}?id=${groupId}`);
  };

  return (
    <Box className={classes.GroupCard} style={{ cursor: 'pointer' }} onClick={handleJoinClick}>
      <img src={coverImage} alt="Discover Group" style={{ borderRadius: '10px 10px 0px 0px',height:140,width:"100%" }} />
      <Box component={'div'} sx={{ padding: '10px 0px 0px 20px',
        '@media (max-width:626px)': {
          padding: '10px 0px 0px 5px !important',
        },
       }}>
        <Typography className={classes.classSixteen}>{groupName}</Typography>
        {/* <Typography className={classes.cardActionContainerTypo}>{memberCount} members</Typography> */}

        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', paddingTop: '2px' }}>
          <AvatarGroup max={4} className={classes.cardAvatarGroup}>
            {/* Dummy avatars since API doesn't provide members list */}
            <Avatar alt="User" src={Images.Images.DefaultProfileImage} sx={{ width: '18px', height: '18px', fontSize: '12px' }} />
          </AvatarGroup>
          <Typography sx={{ fontSize: '9px', fontWeight: '400' }}>
            {memberCount > 0 ? `+${memberCount} members` : 'No members yet'}
          </Typography>
        </Box>

        <div className={classes.cardActionContainer}>
          <Typography sx={{ fontSize: '10.5px', fontWeight: '500' }}>View details</Typography>
          <IconButton sx={{ marginRight: '10px' }}>
            <img src={Images.Icons.ArrowForward} alt="ArrowForward" height={'12px'} width={'12px'} />
          </IconButton>
        </div>
      </Box>
    </Box>
  );
};

export default YourGroupCard;
